// extracted by mini-css-extract-plugin
export default {"container":"kh8otA6j9rLWcKFP7sLzt","canvasContainer":"_3x3zLxpXo8KzWa9srLY8ZR"};